import {getUserId} from '@Libraries/user.library';
import {openPremiumAgreementModal} from '@Modals/premium-agreement-modal';

const GETTY_LICENSE_NAME = 'getty';
const CACHE_ITEM_VALUE = 'yes';

let premiumAgreement: boolean = false;
const hasAgreedToPremiumLicense = async (): Promise<boolean> => {
  premiumAgreement = premiumAgreement || !!(await checkIfHasAgreedToLicense());
  return premiumAgreement;
};

const checkIfHasAgreedToLicense = async (): Promise<string> => {
  const cacheKey = getCacheKey();
  let hasAgreedTo = '';

  try {
    hasAgreedTo = (await window.PMW.readLocal('user/hasuseragreedto', {license: GETTY_LICENSE_NAME}, cacheKey)) as string;
  } catch (e: any) {
    return '';
  }

  return hasAgreedTo;
};

const getCacheKey = (): string => {
  const userId = getUserId();
  if (userId !== null) {
    return GETTY_LICENSE_NAME + userId;
  }
  return '';
};

export const addUserGettyAgreement = async (): Promise<void> => {
  await window.PMW.writeLocal('user/adduseragreement', {license: GETTY_LICENSE_NAME});
  window.PMW.setCacheItem(getCacheKey(), CACHE_ITEM_VALUE);
};

const showPremiumLicenseAgreement = async (): Promise<boolean> => {
  premiumAgreement = await new Promise((resolve) => {
    openPremiumAgreementModal({
      onDecision: resolve,
    });
  });

  return premiumAgreement;
};

export const validateGettyLicenseAgreement = async (): Promise<boolean> => {
  let agreed = await hasAgreedToPremiumLicense();
  if (!agreed) {
    agreed = await showPremiumLicenseAgreement();
  }

  return agreed;
};
